const top = {
  'topTitle': 'トップ'
}

export default top